@if (authService.currentUser()) {
  <button class="relative flex h-12 w-12 shrink-0 items-center justify-center rounded-lg text-white" (click)="menuStateService.toggleMobileUserMenu()">
    <app-user-icon />
    <app-red-dot
      [visible]="versionService.versionIsBrandNew() || versionService.updateAvailable()"
      styleClass="animate-bounce right-1 top-1 !h-[14px] !w-[14px]" />
  </button>
}

<div
  class="relative z-50 transition-all duration-300 ease-in-out"
  [ngClass]="{
    'pointer-events-none invisible opacity-0': !menuStateService.mobileUserMenuOpen(),
    'visible opacity-100': menuStateService.mobileUserMenuOpen(),
  }">
  <div role="none" class="fixed inset-0 bg-[rgba(0,0,0,0.2)]" (click)="menuStateService.toggleMobileUserMenu(false)"></div>
  <div
    class="fixed bottom-0 right-0 top-0 z-50 w-full transform bg-black text-white transition-all duration-300 ease-in-out md:w-1/2"
    [ngClass]="{
      'translate-x-0': menuStateService.mobileUserMenuOpen(),
      'translate-x-full': !menuStateService.mobileUserMenuOpen(),
    }">
    <div class="flex h-full flex-col p-6">
      <!-- Header -->
      <div class="flex justify-between">
        <a routerLink="chat" (click)="menuStateService.toggleMobileUserMenu()">
          <span class="icon-qira-logo text-3xl"></span>
        </a>
        <p-button
          size="small"
          [rounded]="true"
          [text]="true"
          severity="secondary"
          icon="pi pi-times-circle"
          class="[&_.p-button-icon]:text-zinc-200"
          (onClick)="menuStateService.toggleMobileUserMenu(false)" />
      </div>

      <!-- Sound toggle -->
      <!--      <div class="mx-1 mt-8 flex justify-start">-->
      <!--        <mat-slide-toggle-->
      <!--          color="primary"-->
      <!--          labelPosition="before"-->
      <!--          [checked]="voiceService.audioEnabled()"-->
      <!--          (change)="voiceService.audioEnabled.set(!voiceService.audioEnabled())"-->
      <!--          class="flex"-->
      <!--          ><span class="text-white text-center font-bold"-->
      <!--            >Mit Ton</span-->
      <!--          ></mat-slide-toggle-->
      <!--        >-->
      <!--      </div>-->

      <nav class="flex-1 pt-8">
        @if (authService.currentUser()) {
          <!-- User info -->
          <div class="w-full py-8 text-center">
            <button [routerLink]="'/profile/me'" (click)="menuStateService.toggleMobileUserMenu()">
              <app-user-icon size="large" />
            </button>
          </div>

          <!-- User menu items -->
          <div class="mt-2 flex flex-col items-stretch">
            <button [routerLink]="'/profile/me'" (click)="menuStateService.toggleMobileUserMenu()" class="flex items-center gap-4 py-4">
              <i class="pi pi-user !text-lg text-zinc-200"></i>
              {{ 'user.menu.profile' | transloco }}
            </button>

            <app-trigger-release-notes
              [updatesAvailable]="versionService.versionIsBrandNew() || versionService.updateAvailable()"
              buttonClass="py-4 flex-1 [&_.pi]:text-zinc-200" />

            @if (isAdmin()) {
              <button
                [routerLink]="'/devices'"
                (click)="menuStateService.toggleMobileUserMenu()"
                class="flex items-center gap-4 py-4 disabled:text-stone-400"
                [disabled]="subscriptionExpired()">
                <i class="pi pi-file-edit !text-lg text-zinc-200"></i>
                {{ 'user.menu.manageDevices' | transloco }}
              </button>
            }

            <button (click)="authService.logout()" class="flex items-center gap-4 py-4">
              <i class="pi pi-power-off !text-lg text-zinc-200"></i>
              @if (isAdmin()) {
                {{ 'user.menu.logout' | transloco }}
              } @else {
                {{ 'user.menu.logoutDevice' | transloco }}
              }
            </button>
          </div>
        }
      </nav>

      <div class="flex justify-between gap-4 pt-8">
        <!-- Cookie consent -->
        @if (gtmIsEnabled()) {
          <a href="?cmpscreen" class="cmpfooterlink cmpfooterlinkcmp text-sm text-stone-400">
            {{ 'user.menu.cookieSettings' | transloco }}
          </a>
        }
      </div>

      <!-- Legal Pages -->
      <div class="flex justify-between gap-4 pb-5 pt-4">
        <div class="flex gap-4 pb-1 text-left lg:pt-6">
          <a href="https://qira.net/imprint" target="_blank" class="text-sm text-stone-400">
            {{ 'legal.imprint' | transloco }}
          </a>
          <a href="https://qira.net/privacy" target="_blank" class="text-sm text-stone-400">
            {{ 'legal.privacy' | transloco }}
          </a>
          <a href="https://qira.net/terms" target="_blank" class="text-sm text-stone-400">
            {{ 'legal.tac' | transloco }}
          </a>
        </div>
      </div>
    </div>
  </div>
</div>
